export function distanceText(distanceInFeet) {
  if (distanceInFeet >= 2640) { // 0.5 miles in feet
    const miles = distanceInFeet / 5280
    return `${miles.toFixed(1)} miles`
  } else {
    return `${distanceInFeet.toFixed(0)} ft`
  }
}

export function feetToMeters(feet) {
  return feet * 0.3048
}

export function metersToFeet(meters) {
  return meters / 0.3048
}
